import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import './Header.css';

const HeaderComponent = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleDropdown = (menu) => {
    setIsDropdownOpen((prev) => (prev === menu ? null : menu));
  };

  return (
    <header className="bg-[#00318e] shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <Link to="/" className="flex items-center space-x-2">
          <img
            src="/logo.png"
            alt="IPSA_Logo"
            className="w-12 h-12 object-contain rounded shadow-md"
          />
          <span className="text-xl font-bold text-white hidden sm:inline">IPSA Portal</span>
        </Link>

        <button
          className="sm:hidden text-white focus:outline-none"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? (
            <XMarkIcon className="h-6 w-6" />
          ) : (
            <Bars3Icon className="h-6 w-6" />
          )}
        </button>

        <nav className="hidden sm:flex space-x-6 items-center">
          <Link to="/" className="text-white hover:underline">Home</Link>
          <Link to="/about-us" className="text-white hover:underline">About</Link>
          <Link to="/news" className="text-white hover:underline">News</Link>

          <div className="relative">
            <button
              onClick={() => toggleDropdown('policies')}
              className="text-white hover:underline focus:outline-none"
            >
              Policies ▾
            </button>
            {isDropdownOpen === 'policies' && (
              <div className="absolute top-full left-0 mt-2 bg-[#00318e] shadow-lg rounded-md w-48 z-10">
                <Link to="/policies/free" className="block px-4 py-2 text-white hover:bg-blue-800">Free Policies</Link>
                <Link to="/policies/paid" className="block px-4 py-2 text-white hover:bg-blue-800">Paid Policies</Link>
              </div>
            )}
          </div>

          <div className="relative">
            <button
              onClick={() => toggleDropdown('systems')}
              className="text-white hover:underline focus:outline-none"
            >
              Systems ▾
            </button>
            {isDropdownOpen === 'systems' && (
              <div className="absolute top-full left-0 mt-2 bg-[#00318e] shadow-lg rounded-md w-48 z-10">
                <Link to="/systems/overview" className="block px-4 py-2 text-white hover:bg-blue-800">System Overview</Link>
                <Link to="/systems/demo" className="block px-4 py-2 text-white hover:bg-blue-800">Video Demos</Link>
              </div>
            )}
          </div>
          <Link to="/contact-us" className="text-white hover:underline">Contact</Link>
        </nav>

        <div className="hidden sm:flex space-x-3">
          <Link to="/login" className="text-white">Login</Link>
          <Link to="/register" className="bg-white text-[#00318e] px-3 py-1 rounded hover:bg-gray-100 font-medium">Register</Link>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="sm:hidden bg-[#00318e] px-4 py-3 space-y-2">
          <Link to="/" className="block text-white hover:underline">Home</Link>
          <Link to="/about" className="block text-white hover:underline">About</Link>
          <Link to="/news" className="block text-white hover:underline">News</Link>
          <Link to="/policies/free" className="block text-white hover:underline">Free Policies</Link>
          <Link to="/policies/paid" className="block text-white hover:underline">Paid Policies</Link>
          <Link to="/systems/overview" className="block text-white hover:underline">System Overview</Link>
          <Link to="/systems/demo" className="block text-white hover:underline">Video Demos</Link>
          <Link to="/contact" className="block text-white hover:underline">Contact</Link>
          <Link to="/login" className="block text-white hover:underline">Login</Link>
          <Link to="/register" className="block text-white hover:underline">Register</Link>
        </div>
      )}
    </header>
  );
};

export default HeaderComponent;
